/**
 * orga-app-api - displaysteuerung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BereichTriggerDatenRequest { 
    anzeige_name: string;
    reihenfolge?: number;
    icon?: string;
    trigger_id: string;
    bereich_id: string;
}

